import { tierTokenTypes } from 'app/frontend/types/custom/TierTokenType'
import { CharacterClassIcon } from 'app/frontend/base/components'
import StatTable from './StatTable'
import { CharacterClass } from 'app/frontend/types/custom'

const TierTokens = ({ className }: { className?: string }) => {
  return (
    <StatTable<CharacterClass[]>
      className={className}
      title='Tier token'
      subject={tierTokenTypes}
      memberFilterFn={(member, classes) =>
        classes.includes(member.characterReference.characterClass)
      }
      valueFn={(token, classes) => (
        <span className='flex w-full items-center justify-between gap-3'>
          {token}
          <div className='flex gap-1'>
            {classes.map((c) => (
              <CharacterClassIcon key={c} characterClass={c} size='small' />
            ))}
          </div>
        </span>
      )}
    />
  )
}

export default TierTokens
